import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { isStorybook, memoryStorage } from "./persistUtils.ts";

interface QuickMenuState {
  // 사용자가 고른 메뉴 url. null 이면 고른 적이 없다 — 쓰는 쪽이 기본 목록을 쓴다.
  // 기본 목록을 여기에 복사해 두지 않는 이유: 기본이 바뀌었을 때 고른 적 없는
  // 사람은 새 기본을 따라가야 하기 때문이다.
  selectedUrls: string[] | null;
  setSelectedUrls: (urls: string[]) => void;
  // 고른 것을 지우고 기본으로 돌아간다.
  resetSelectedUrls: () => void;
  // 띠를 접어 둔 상태. 접어 두면 다음에 열 때도 접혀 있다. 선택과 달리 기본(false)이
  // 바뀔 일이 없어 값을 그대로 저장한다.
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

// 브라우저(localStorage)마다 따로 저장한다 — 계정이나 기기를 따라가지 않는다.
export const useQuickMenuStore = create<QuickMenuState>()(
  persist(
    (set) => ({
      selectedUrls: null,
      setSelectedUrls: (urls) => set({ selectedUrls: urls }),
      resetSelectedUrls: () => set({ selectedUrls: null }),
      collapsed: false,
      setCollapsed: (collapsed) => set({ collapsed }),
    }),
    {
      name: "quick-menu-store",
      // Storybook 에서 dev 앱의 영속 키를 덮어쓰지 않도록 in-memory 로 대체한다.
      storage: createJSONStorage(() =>
        isStorybook ? memoryStorage() : localStorage,
      ),
      // 액션은 직렬화되지 않으므로 값만 영속한다.
      partialize: (state) => ({
        selectedUrls: state.selectedUrls,
        collapsed: state.collapsed,
      }),
    },
  ),
);
